import { useState } from "react";

import ConfirmModal from "@/components/Modal/ConfirmModal";
import OrgToolbar from "@/pages/Admin/components/OrgManagement/OrgToolbar";
import OrgTreePanel from "@/pages/Admin/components/OrgManagement/OrgTreePanel";
import UserListModal from "@/pages/Admin/components/OrgManagement/UserListModal";
import { MobileTab } from "@/pages/Admin/components/OrgManagement/types";
import useOrgActions from "@/pages/Admin/components/OrgManagement/useOrgActions";
import useOrgTree from "@/pages/Admin/components/OrgManagement/useOrgTree";

// ============================================================
// 메인: OrgManagement
// ============================================================

const OrgManagement = () => {
  // 모바일 탭
  const [mobileTab, setMobileTab] = useState<MobileTab>("cmt");

  // 삭제 모드
  const [deleteMode, setDeleteMode] = useState(false);

  // 조직 데이터/선택 상태 + CRUD 액션 (상태는 모두 이 컴포넌트에서 소유)
  const tree = useOrgTree();
  const actions = useOrgActions(tree);

  const {
    confirmModal,
    pendingDelete,
    setPendingDelete,
    userListModal,
    userListOrg,
    setUserListOrg,
    handleMoveUsers,
    handleConfirmDelete,
  } = actions;

  return (
    <div className="flex w-full flex-col gap-4 p-4 text-base text-black">
      <OrgToolbar
        deleteMode={deleteMode}
        onToggleDeleteMode={() => setDeleteMode(v => !v)}
        mobileTab={mobileTab}
        onChangeMobileTab={setMobileTab}
      />

      <OrgTreePanel
        tree={tree}
        actions={actions}
        deleteMode={deleteMode}
        mobileTab={mobileTab}
      />

      {/* 삭제 확인 모달 */}
      {confirmModal.isOpen && pendingDelete && (
        <ConfirmModal
          title="삭제 확인"
          onConfirm={handleConfirmDelete}
          onClose={() => {
            confirmModal.onClose();
            setPendingDelete(null);
          }}
        >
          {`'${pendingDelete.nm}'을(를) 삭제하시겠습니까?`}
        </ConfirmModal>
      )}

      {/* 유저 목록 모달 */}
      {userListModal.isOpen && userListOrg && (
        <UserListModal
          orgName={userListOrg.name}
          users={userListOrg.users}
          communities={tree.communities}
          onMove={handleMoveUsers}
          onClose={() => {
            userListModal.onClose();
            setUserListOrg(null);
          }}
        />
      )}
    </div>
  );
};

export default OrgManagement;
